import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Grid,
  Icon,
  Input,
  Image,
  Pagination,
  Checkbox,
  Modal,
  Loader,
} from "semantic-ui-react";
import AddSkills from "../layout/AddSkills";
import { connect, useDispatch } from "react-redux";
import { firestoreConnect, isLoaded } from "react-redux-firebase";
import { compose } from "redux";
import {
  deletePlaylist,
  editPlaylist,
  setActive,
} from "../../store/actions/athleteActions";
import { Redirect } from "react-router-dom";
import { imageRegex, ytPlaylistRegex } from "../../utils/regex";
const SkillsList = (props) => {
  // defining States & Dispatch
  const [data, setData] = useState(null);
  const [addSkillOpen, setAddSkillOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [playlists, setPlaylists] = useState([]);
  const [activePlaylist, setActivePlaylist] = useState([]);
  const [confirmationPopup, setConfirmationPopup] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [editIndex, setEditIndex] = useState(null);
  const [deleteTitle, setDeleteTitle] = useState(null);
  const [thumbnail, setThumbnail] = useState(null);
  const [thumbnailUrl, setThumbnailUrl] = useState(null);
  const [error, setError] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [title, setTitle] = useState(null);
  const [url, setUrl] = useState(null);
  const [changesMade, setChangesMade] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const dispatch = useDispatch();

  // Open and Close Add Skill Modal
  const handleAddSkillOpen = () => {
    setAddSkillOpen(true);
  };
  const handleAddSkillClose = () => {
    setAddSkillOpen(false);
  };

  // Pagination

  const pageChange = (not, data) => {
    setActivePage(data.activePage);
  };

  // Getting Data From Props to save it in the State
  useEffect(() => {
    if (props.playlistsData) {
      setData(props.playlistsData);
    }
  }, [props.playlistsData]);

  useEffect(() => {
    if (data) {
      let storingObject = Object.keys(data);
      let object = [];
      let activeObject = [];
      if (storingObject.length > 0) {
        object = storingObject.map((key) => {
          return {
            id: data[key].id,
            title: data[key].title,
            playlistUrl: data[key].playlistUrl,
            thumbnailUrl: data[key].thumbnailUrl,
            modifiedAt: data[key].modifiedAt,
            createdAt: data[key].createdAt,
            active: data[key].active,
          };
        });
      }
      // same as above just filtering data if it is active
      if (storingObject.length > 0) {
        activeObject = storingObject.map((key) => {
          if (data[key].active) {
            return {
              id: data[key].id,
              title: data[key].title,
              playlistUrl: data[key].playlistUrl,
              thumbnailUrl: data[key].thumbnailUrl,
              modifiedAt: data[key].modifiedAt,
              createdAt: data[key].createdAt,
              active: data[key].active,
            };
          }
        });
        // this filtering is for undefined data
        activeObject = activeObject.filter((active) => active);
      }
      setTotalPages(object.length / 5);
      object = object && object.slice((activePage - 1) * 5, activePage * 5);
      setPlaylists(object);
      setActivePlaylist(activeObject);
    }
  }, [data, activePage]);

  // On Toggle Click Change Active and InActive in Database
  const handleActiveChange = (id, activeStatus) => {
    if (activePlaylist.length < 5)
      playlists.map((playlist) => {
        id === playlist.id && dispatch(setActive(id, activeStatus));
      });
  };

  // Delete Functionality (Currently it is deleting from firestore not from firebase)
  const handleDelete = () => {
    let fieldsArray = [...playlists];
    const storingArray = fieldsArray.filter(
      (field) => field.id !== deleteIndex
    );
    setPlaylists(storingArray);
    dispatch(deletePlaylist(deleteIndex));
    setConfirmationPopup(false);
    setDeleteIndex(null);
  };
  // Getting Inputs And Submitting Them
  const handleSubmit = () => {
    if (editIndex) {
      let submissionObject = { id: editIndex };
      if (thumbnail) {
        submissionObject.thumbnail = thumbnail;
      }
      if (title) {
        submissionObject.title = title;
      }
      if (url) {
        submissionObject.playlistUrl = url;
      }
      if (Object.keys(submissionObject).length <= 1) {
        setEdit(false);
      } else {
        dispatch(editPlaylist(submissionObject));
        setUploading(true);
        setTimeout(() => {
          setUploading(false);
          setEditIndex(null);
          setEdit(null);
          setError(false);
          setThumbnail(null);
          setThumbnailUrl(null);
          setTitle(null);
          setUrl(null);
          setChangesMade(false);
        }, 3000);
      }
    }
  };

  const handleThumbnail = (e) => {
    if (imageRegex.test(e.target.files[0].name)) {
      setThumbnailUrl(URL.createObjectURL(e.target.files[0]));
      setThumbnail(e.target.files[0]);
      setChangesMade(true);
    } else {
      setError("It should be image");
    }
  };
  const handleTitleChange = (data) => {
    if (data === "") {
      setError("Title should not be empty");
      setChangesMade(false);
    } else {
      setTitle(data);
      setError(false);
      setChangesMade(true);
    }
  };
  const handleUrlChange = (data) => {
    if (ytPlaylistRegex.test(data)) {
      setUrl(data);
      setError(false);
      setChangesMade(true);
    } else {
      setError("It should be youtube playlist");
      setChangesMade(false);
    }
  };
  // Some Buttons
  const editButton = (id) => (
    <Button
      color="blue"
      className="edit-li"
      name="RemovePlayerButton"
      onClick={() => {
        setEditIndex(id);
        setEdit(!edit);
      }}
    >
      <Icon name="pencil" />
    </Button>
  );
  const saveButton = () => {
    if (changesMade && !uploading) {
      return (
        <Button
          color="green"
          className="save-li"
          name="savePlayerButton"
          onClick={handleSubmit}
        >
          <Icon name="check" />
        </Button>
      );
    } else if (!changesMade && !uploading) {
      return (
        <Button
          disabled
          color="green"
          className="save-li"
          name="savePlayerButton"
        >
          <Icon name="check" />
        </Button>
      );
    } else {
      return (
        <Button
          loading
          disabled
          color="green"
          className="save-li"
          name="savePlayerButton"
        >
          <Icon name="check" />
        </Button>
      );
    }
  };
  const cancelButton = (
    <Button
      color="blue"
      className="edit-li"
      name="RemovePlayerButton"
      onClick={() => {
        setEditIndex(null);
        setEdit(null);
        setError(false);
        setThumbnail(null);
        setThumbnailUrl(null);
        setTitle(null);
        setUrl(null);
        setChangesMade(false);
      }}
    >
      <Icon name="cancel" />
    </Button>
  );
  let card;
  if (!props.superAdmin) {
    return <Redirect to="/playlists" />;
  } else {
    if (playlists.length > 0) {
      card = playlists.map((playlist) => {
        return (
          <li key={playlist.id}>
            <Button
              color="red"
              className="delete-li"
              name="RemovePlayerButton"
              onClick={() => {
                setDeleteIndex(playlist.id);
                setDeleteTitle(playlist.title);
                setConfirmationPopup(true);
              }}
            >
              <Icon name="minus" />
            </Button>
            {!edit && editButton(playlist.id)}
            {edit && editIndex === playlist.id && cancelButton}
            {edit && editIndex === playlist.id && saveButton()}
            <div
              className={`full-skills ${
                edit && editIndex === playlist.id ? "" : "non-editable"
              }`}
            >
              <div className="one-skill">
                {edit &&
                  editIndex !== playlist.id &&
                  !isLoaded(playlist.thumbnailUrl) && <Loader />}
                {edit &&
                  editIndex !== playlist.id &&
                  isLoaded(playlist.thumbnailUrl) && (
                    <Image src={playlist.thumbnailUrl} />
                  )}
                {!edit && editIndex !== playlist.id && (
                  <Image src={playlist.thumbnailUrl} />
                )}
                {edit && editIndex === playlist.id && thumbnailUrl && (
                  <Image src={thumbnailUrl} />
                )}
                {edit &&
                  editIndex === playlist.id &&
                  !thumbnailUrl &&
                  isLoaded(playlist.thumbnailUrl) && (
                    <Image src={playlist.thumbnailUrl} />
                  )}
                {edit &&
                  editIndex === playlist.id &&
                  !thumbnailUrl &&
                  !isLoaded(playlist.thumbnailUrl) && <Loader />}
                {edit && edit && editIndex === playlist.id && (
                  <>
                    <label for="thumbnail">
                      <Icon name="upload" />
                    </label>
                    <Input
                      type="file"
                      id="thumbnail"
                      style={{ display: "none" }}
                      placeholder="Select image"
                      onChange={handleThumbnail}
                    />
                  </>
                )}
              </div>
              <div className="two-skill">
                <Grid divided="vertically">
                  <Grid.Row stackable="true" columns={2}>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      <Form.Field>
                        <label>Title</label>
                        {!edit && editIndex !== playlist.id && (
                          <Input
                            placeholder="Title"
                            value={playlist.title}
                            defaultValue={playlist.title}
                            onChange={(e) => handleTitleChange(e.target.value)}
                          />
                        )}
                        {edit && (
                          <Input
                            placeholder="Title"
                            defaultValue={playlist.title}
                            onChange={(e) => handleTitleChange(e.target.value)}
                          />
                        )}
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      <Form.Field>
                        <label>Youtube URL</label>
                        {!edit && editIndex !== playlist.id && (
                          <Input
                            placeholder="Youtube URL"
                            value={playlist.playlistUrl}
                          />
                        )}
                        {edit && (
                          <Input
                            placeholder="Youtube URL"
                            defaultValue={playlist.playlistUrl}
                            onChange={(e) => handleUrlChange(e.target.value)}
                          />
                        )}
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      <Form.Field>
                        <label>Active / Inactive</label>
                        <div>
                          {activePlaylist.length === 4 && !playlist.active && (
                            <Checkbox
                              toggle
                              disabled
                              defaultChecked={playlist.active}
                              onChange={() => {
                                handleActiveChange(
                                  playlist.id,
                                  !playlist.active
                                );
                              }}
                            />
                          )}
                          {activePlaylist.length === 4 && playlist.active && (
                            <Checkbox
                              toggle
                              defaultChecked={playlist.active}
                              onChange={() => {
                                handleActiveChange(
                                  playlist.id,
                                  !playlist.active
                                );
                              }}
                            />
                          )}
                          {activePlaylist.length < 4 && (
                            <Checkbox
                              toggle
                              defaultChecked={playlist.active}
                              onChange={() => {
                                handleActiveChange(
                                  playlist.id,
                                  !playlist.active
                                );
                              }}
                            />
                          )}
                        </div>
                      </Form.Field>
                      {changesMade &&
                        props.progress > 0 &&
                        editIndex === playlist.id && (
                          <p style={{ color: "#FF6600" }}>
                            Please Wait While Uploading and Rendering Thumbnail
                          </p>
                        )}
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      {edit && editIndex === playlist.id && (
                        <p style={{ color: "#800000" }}>{error}</p>
                      )}
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </div>
            </div>
          </li>
        );
      });
    } else {
      card = <p className="not-found">There's No Data Right Now</p>;
    }
  }

  return (
    <div className="HomeContainer">
      <div className="SkillsList">
        <h1>Skills List</h1>
        <div className="btn-data with-flex">
          <Button
            icon
            labelPosition="left"
            color="green"
            name="AddSkillButton"
            onClick={handleAddSkillOpen}
          >
            <Icon name="plus" />
            Add Skills
          </Button>
          {playlists.length > 0 && <p>*At a time 4 will be active.</p>}
        </div>
        <ul>{card}</ul>
        {confirmationPopup && (
          <Modal className="delete-popup" open={confirmationPopup}>
            <Modal.Content>
              <p className="p1">Are you sure want to delete </p>
              <p className="p1">
                <b>{deleteTitle}?</b>
              </p>
              <p className="p2">This process cannot be undone.</p>
              <div className="delete-modal-footer">
                <Button
                  name="closeButton"
                  content="Cancel"
                  onClick={() => {
                    setConfirmationPopup(false);
                    setDeleteIndex(null);
                  }}
                />
                <Button
                  color="red"
                  name="saveButton"
                  content="Delete"
                  onClick={handleDelete}
                />
              </div>
            </Modal.Content>
          </Modal>
        )}
        {/* pagination and pages show */}
        {totalPages > 1 && (
          <div className="AthleteSearchDetail AthletePagination">
            <Pagination
              onPageChange={pageChange}
              defaultActivePage={1}
              firstItem={null}
              lastItem={null}
              prevItem={{ content: <Icon name="angle left" />, icon: true }}
              nextItem={{ content: <Icon name="angle right" />, icon: true }}
              pointing
              secondary
              totalPages={totalPages}
            />
          </div>
        )}
      </div>
      <AddSkills open={addSkillOpen} onClose={handleAddSkillClose} />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    close: state.athlete.playerToWatchAdded,
    playlistsData: state.firestore.ordered.skillsPlaylists,
    progress: state.athlete.skillUpdateProgress,
    superAdmin: state.auth.superAdmin,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "skillsPlaylists",
    },
  ])
)(SkillsList);
